import { useDispatch, useSelector } from "react-redux";
import { Button, Dropdown, Skeleton, Tooltip } from "antd";
import styles from "../../../styles/Components/bot/bot-overview/BotList.module.css";
import BotIcon from "../../../ui/icons/BotIcon";
import { PiChartLineUpBold } from "react-icons/pi";
import React, { useState } from "react";
import { MdMoreHoriz } from "react-icons/md";
import useUserData from "../../../hooks/useUserData";
import {
  checkBotStatus,
  deactivateBot,
  getBotPerformanceReportPdf,
  getLatestBacktest,
} from "../../../redux/bot/actions";
import DisplayBotStatus from "../../../shared/bot-activation-process/DisplayBotStatus";
import useServiceStatus from "../../../hooks/useServiceStatus";
import { RiLockFill } from "react-icons/ri";
import ActivateBotServiceModal from "../ActivateBotServiceModal";
import BacktestModal from "../bot-backtest/BacktestModal";
import PerformanceReportModal from "../bot-reports/PerformanceReportModal";
import { BsRobot } from "react-icons/bs";
import CreateBot from "../CreateBot";

export function BotItem({ data, isMiniApp = false }) {
  const {
    botState: {
      activateBotLoading,
      latestBacktests,
      deactivateBotLoading,
      performanceReports,
      performanceReportsStatus,
      performanceReportsError,
    },
  } = useSelector((state) => state);

  const {
    bot_name: name,
    profit_percent: profit,
    status,
    bot_creation_id: id,
    exchange_id: exchangeId,
    win_rate: winRate,
    last_week_profit: lastWeekProfit,
  } = data;

  const performanceReportStatus = performanceReportsStatus?.[id];
  const performanceReport = performanceReports?.[id];

  const [targetBot, setTargetBot] = useState(null);
  const [showBotActivationModal, setShowBotActivationModal] = useState(false);
  const [showServiceActivationModal, setShowServiceActivationModal] =
    useState(false);
  const [showBacktestModal, setShowBacktestModal] = useState(false);
  const [showPerformanceReportModal, setShowPerformanceReportModal] =
    useState(false);
  const [showFullName, setShowFullName] = useState(false);

  const dispatch = useDispatch();
  const { username, email } = useUserData();
  const { isActive: isBotServiceActive } = useServiceStatus("bot");

  const isLoading = Boolean(
    targetBot === id && (activateBotLoading || deactivateBotLoading),
  );

  const moreItems = [
    { key: "performance", label: "Performance Report" },
    { key: "backtest", label: "Backtest Report" },
  ];

  const handleMenuClick = ({ key }) => {
    if (!isBotServiceActive) return setShowServiceActivationModal(true);

    switch (key) {
      case "performance":
        if (
          !performanceReport?.pdf_url &&
          performanceReportStatus !== "loading" &&
          performanceReportStatus !== "success"
        ) {
          dispatch(getBotPerformanceReportPdf(username, email, id));
        }
        setShowPerformanceReportModal(true);

        // if (!performanceReport) {
        //   setShowPerformanceReportModal(true);
        // }
        break;
      case "backtest":
        if (
          !latestBacktests?.[id] ||
          latestBacktests?.[id]?.status === "not_processed"
        ) {
          dispatch(getLatestBacktest(username, email, id));
        }
        setShowBacktestModal(true);
        break;
      default:
        break;
    }
  };

  const activationHandler = () => {
    if (!isBotServiceActive) {
      setShowServiceActivationModal(true);
      return;
    }

    setTargetBot(id);
    if (status === "Active") {
      dispatch(deactivateBot(username, email, id));
    } else {
      dispatch(checkBotStatus(username, email, id, exchangeId));
      setShowBotActivationModal(true);
    }
  };

  return (
    <>
      <div className={styles.botItem}>
        <div className={styles.header}>
          <div className={styles.headerLeft}>
            <div className={styles.botIcon}>
              {" "}
              <BotIcon />
            </div>
          </div>
          <div className={styles.headerRight}>
            <span
              className={`${styles.status} ${status === "Active" ? styles.activeStatus : styles.inactiveStatus}`}
            >
              {status}
            </span>
            <div className={styles.logoContainer}>
              <img
                src={`https://cryptocrispypro.s3.ap-southeast-2.amazonaws.com/crypto_exchanges_logo/${exchangeId}.svg`}
                alt={exchangeId}
                className={styles.exchangeLogo}
              />
            </div>
          </div>
        </div>

        <Tooltip
          title={name}
          placement="bottom"
          color="#0c4cfc"
          open={showFullName}
        >
          <h6
            className={styles.botName}
            onMouseEnter={() => setShowFullName(true)}
            onMouseLeave={() => setShowFullName(false)}
          >
            {name}
          </h6>
        </Tooltip>

        <div className={styles.botInfo}>
          <PiChartLineUpBold color="rgb(13, 74, 249)" />
          Profit:{" "}
          <span className={profit !== "N/A" ? styles.profit : ""}>
            {profit} {profit !== "N/A" ? "%" : ""}
          </span>
        </div>

        <div className={styles.botInfo}>
          <PiChartLineUpBold color="rgb(13, 74, 249)" />
          Last Week Profit:{" "}
          <span className={lastWeekProfit !== "N/A" ? styles.profit : ""}>
            {lastWeekProfit} {lastWeekProfit !== "N/A" ? "%" : ""}
          </span>
        </div>

        <div className={styles.botInfo}>
          <PiChartLineUpBold color="rgb(13, 74, 249)" />
          Win Rate:{" "}
          <span className={winRate !== "N/A" ? styles.profit : ""}>
            {winRate}
            {/*{winRate !== "N/A" ? "%" : ""}*/}
          </span>
        </div>

        <div className={styles.handlers}>
          <Button
            className={`${styles.actionBtn} ${styles.activationBtn}`}
            loading={isLoading}
            disabled={isLoading}
            onClick={activationHandler}
          >
            {!isBotServiceActive && <RiLockFill size={12} />}
            {status === "Active" ? "Deactivate" : "Activate"}?
          </Button>

          <Dropdown
            menu={{ items: moreItems, onClick: handleMenuClick }}
            placement="bottomLeft"
            trigger={["click"]}
            rootClassName={styles.dropdownMenu}
          >
            <Button className={`${styles.actionBtn} ${styles.moreMenu}`}>
              See More <MdMoreHoriz />
            </Button>
          </Dropdown>
        </div>
      </div>

      <DisplayBotStatus
        show={showBotActivationModal}
        onClose={setShowBotActivationModal}
        botId={id}
        exchangeId={exchangeId}
      />
      {showServiceActivationModal && (
        <ActivateBotServiceModal
          setShowActivationModal={setShowServiceActivationModal}
          showActivationModal={showServiceActivationModal}
        />
      )}

      {showBacktestModal && (
        <BacktestModal
          bot={id}
          botData={data}
          showModal={showBacktestModal}
          closeModal={() => setShowBacktestModal(false)}
          isMiniApp={isMiniApp}
        />
      )}

      {showPerformanceReportModal && (
        <PerformanceReportModal
          open={showPerformanceReportModal}
          close={() => setShowPerformanceReportModal(false)}
          bot={id}
          botInfo={data}
          isMiniApp={isMiniApp}
        />
      )}
    </>
  );
}

function BotList() {
  const {
    dashboard: {
      botInfoStatus,
      overallBotPerformance: { bots_performance: bots = [] },
    },
  } = useSelector((state) => state);

  const botList = [...bots]?.sort((a, _) => (a?.status === "Active" ? -1 : 1));

  return (
    <div className={styles.container}>
      {botInfoStatus !== "success" && bots?.length !== 0 && (
        <h3 className={styles.title}>Bots</h3>
      )}
      <div className={styles.botList}>
        {botInfoStatus === "loading" &&
          Array.from({ length: 4 })?.map((_, index) => (
            <Skeleton.Node active key={index} />
          ))}
        {botInfoStatus === "success" &&
          bots?.length > 0 &&
          botList?.map((bot) => (
            <BotItem data={bot} key={bot?.bot_creation_id} />
          ))}

        {botInfoStatus === "success" && bots?.length === 0 && (
          <div className={styles.emptyBots}>
            <BsRobot size={50} color="rgb(108,117,125)" />
            <h6>Welcome to Bot Automation!</h6>
            <p>You haven't created any trading bots yet. Let's get started!</p>
            <CreateBot title="Create Your First Bot" className={styles.btn} />
            <span>
              Automate your trading strategies and let our AI-powered bots work
              for you 24/7.
            </span>
          </div>
        )}

        {botInfoStatus === "error" && bots?.length === 0 && (
          <div className={styles.emptyBots}>
            <BsRobot size={50} color="rgb(108,117,125)" />
            <p>Data couldn’t be loaded right now. Please try again later.</p>
          </div>
        )}
      </div>
    </div>
  );
}

export default BotList;
